"use client";

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from "next-intl";
import type { FC } from "react";
import { TeamSwitcherAutocomplete } from "./components/TeamSwitcherAutocomplete/TeamSwitcherAutocomplete";
import { TeamSwitcherSelect } from "./components/TeamSwitcherSelect/TeamSwitcherSelect";
import { useOrganizationTeamSwitcher } from "./hooks/useOrganizationTeamSwitcher/useOrganizationTeamSwitcher";
export const TeamSwitcher: FC = () => {
  const $ = _c(14);
  const t = useTranslations("navigation.team_switcher");
  const {
    teams,
    currentTeamId,
    isLoading,
    isUpdating,
    hasSingleTeam,
    hasMultipleOrganizations,
    currentOrganization,
    onTeamChange
  } = useOrganizationTeamSwitcher();
  const currentTeamExists = currentTeamId ? teams.some(team => team.id === currentTeamId) : false;
  const shouldShowSkeleton = isLoading || !currentTeamId || teams.length === 0 || !currentTeamExists;
  const shouldUseAutocomplete = teams.length > 5;
  if (shouldShowSkeleton) {
    let t0;
    if ($[0] !== currentOrganization || $[1] !== hasMultipleOrganizations || $[2] !== t) {
      t0 = hasMultipleOrganizations && currentOrganization ? t("loading_teams_for", {
        organization: currentOrganization
      }) : t("loading_teams");
      $[0] = currentOrganization;
      $[1] = hasMultipleOrganizations;
      $[2] = t;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    let t1;
    if ($[4] !== t0) {
      t1 = <div className="w-full"><div className="flex h-12 w-full items-center rounded-lg border-1 border-blue-650 px-3"><span className="text-default-500 text-xs">{t0}</span></div></div>;
      $[4] = t0;
      $[5] = t1;
    } else {
      t1 = $[5];
    }
    return t1;
  }
  let t0;
  if ($[6] !== currentTeamId || $[7] !== hasSingleTeam || $[8] !== isLoading || $[9] !== isUpdating || $[10] !== onTeamChange || $[11] !== shouldUseAutocomplete || $[12] !== teams) {
    t0 = <div className="w-full">{shouldUseAutocomplete ? <TeamSwitcherAutocomplete teams={teams} selectedTeamId={currentTeamId} isLoading={isLoading} isUpdating={isUpdating} hasSingleTeam={hasSingleTeam} onSelectionChange={onTeamChange} /> : <TeamSwitcherSelect teams={teams} selectedTeamId={currentTeamId} isLoading={isLoading} isUpdating={isUpdating} hasSingleTeam={hasSingleTeam} onSelectionChange={onTeamChange} />}</div>;
    $[6] = currentTeamId;
    $[7] = hasSingleTeam;
    $[8] = isLoading;
    $[9] = isUpdating;
    $[10] = onTeamChange;
    $[11] = shouldUseAutocomplete;
    $[12] = teams;
    $[13] = t0;
  } else {
    t0 = $[13];
  }
  return t0;
};